import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { WalletTransaction } from 'services';
import { Results } from './components';
import { CreateTransactionModal } from 'components';
import { finance_manager } from 'utils/constants';
import { Button } from '@material-ui/core';

const WalletTransactions = props => {
  let { wallet, reload } = props;

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    if (wallet) return (
      <GenericHeader subheader={`Transactions for ${wallet.account.displayname}'s ${wallet.currency} wallet`} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Create Transaction
        </Button>
      </GenericHeader>
    );
    return (
      <GenericHeader header="All Transactions" subheader="Transaction Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={WalletTransaction.list}
      title="Wallet Transactions"
      name="transactions"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateTransactionModal}
      roles={[finance_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "", wallet: wallet ? wallet.id : null }}
      comp_props={{ create_comp: { wallet_id: wallet ? wallet.id : null, reload } }}
    />
  );
};

export default WalletTransactions;
